import React, { useState, useContext } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { useTheme } from '@mui/material/styles';

import ChangeTicketConfirmDialog from './ChangeTicketConfirmDialog';
import useRejectChangeTicket from '../hooks/vendors/useRejectChangeTicket';
import { AppContext } from '../../App';

interface RejectChangeTicketProps {
  ticketId: number;
  vendorName: string;
}

const RejectChangeTicket: React.FC<RejectChangeTicketProps> = ({ ticketId, vendorName }) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const { setToast } = useContext(AppContext);

  const { mutate: rejectChangeTicket, isPending: isLoading } = useRejectChangeTicket({
    onSuccess: () => {
      setOpen(false);
      setToast({
        variant: 'success',
        open: true,
        message: 'Change ticket rejected successfully',
      });
    },
    onError: (error) => {
      console.error('Reject mutation error:', error);
      setToast({
        variant: 'error',
        open: true,
        message: 'Failed to reject change ticket. Please try again.',
      });
    },
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    if (!isLoading) {
      setOpen(false);
    }
  };

  const handleConfirm = () => {
    rejectChangeTicket(ticketId);
  };

  return (
    <>
      <Tooltip placement="top" title="Reject Change Ticket" disableFocusListener disableTouchListener>
        <IconButton
          data-cy={`btn-reject-change-ticket-${vendorName}`}
          onClick={handleClickOpen}
          disabled={isLoading}
          sx={{
            color: theme.palette.error.main,
            '&:hover': {
              backgroundColor: theme.palette.error.main + '20',
            },
          }}
        >
          <CancelIcon fontSize="medium" />
        </IconButton>
      </Tooltip>

      <ChangeTicketConfirmDialog
        open={open}
        onClose={handleClose}
        onConfirm={handleConfirm}
        isLoading={isLoading}
        action="reject"
        vendorName={vendorName}
      />
    </>
  );
};

export default RejectChangeTicket;
